<template>
  <transition name="fade">
    <div class="top" v-show="view">
      <button id="close-top" @click="closeSearch"><i class="fa fa-times"></i></button>
      <p class="txt-search"><i class="fas fa-hand-holding-heart"></i>LOS IMPERDIBLES</p>
      <div class="items-list">
        <div class="item-list" v-for="(i,k) in data" :key="k">
          <ProductTopComponent :key="k" :data="item(i)" :origin="'top'" :category="category" :indice="k"/>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
/* eslint-disable */
import ProductTopComponent from './ProductTopComponent'

export default {
  name: 'Product',
  methods: {
    closeSearch () {
    	this.$parent.viewTop = false
      if (window.screen.width < 1000) {
  		  document.body.style.overflow = 'auto'
      }
    },
    item(sku){
      return this.$parent.productsData[sku]
    }
  },
  data () {
    return {
      query: '',
      legend: ''
    }
  },
  props: {
    view: Boolean,
    data: Array
  },
  components: {
    ProductTopComponent
  }
}
</script>
<style>
  .items-list{    white-space: normal;
    width: 95%;
    margin: auto;
    margin-top: 70px;}
  .item-list {width: 100%!important;
    margin: 10px auto;
    margin-top: 0px;height:auto!important}
.top{position: fixed;bottom: 0px;z-index: 104;background: rgba(255,255,255,1);height: 50vh;overflow: auto;width: 100%;}
#close-top {
  background: none;
    border: none;
    font-size: 1.500em;
    z-index: 104;
    display: block;
    position: fixed;
    right: 10px;
    bottom: 45vh;
}
.top .txt-search{
  margin-top: 0px;
    font-size: 1.250em;
    font-weight: bold;
    height: 25px;
    position: fixed;
    width: 100%;
    background-color: #fff;
    z-index: 103;
    padding-left: 15px;
    padding-top: 15px;
    padding-bottom: 10px;
    bottom: 41vh;
    text-align: left;
    -webkit-box-shadow: 0px 2px 6px 1px #ccc;
    box-shadow: 0px 2px 6px 1px #ccc;
}
.top .txt-search i{display:inline-block;margin-right:10px;color:#E0172F}
input{background:#fff;border:solid thin #ccc;width:79%;padding:10px 3%;border:0px;font-size:1em;position:fixed;z-index:11;left:0px;top:0px;height: 36px;
border-bottom: solid thin #ccc;}
.result{padding-top:60px;}
.result .product-card{display:inline-block;width:80%;vertical-align:top;margin:10px;height:500px}
.legend {
    font-size: 1em;
    padding-top: 103px;
    font-family: 'Open Sans';
}
.orange{color:#E0172F}
@media only screen and (min-width: 1000px) {
  .items-list{white-space: normal;width:95%;margin:auto;overflow-y:scroll;height:80vh;}
  .item-list {width: 100%!important;margin: 10px auto;margin-top: 25px;height:auto!important}
  .top{position:absolute!important;width:100%;height:100vh;z-index:104;background-color:rgba(255,255,255,1);right:0px;width:300px;-webkit-box-shadow: 0px 2px 6px 1px #ff4300fa;
    box-shadow: 0px 2px 6px 1px #ff4300fa;}
  #close-top{position:absolute;top:15px;right:15px;font-size:1.500em;color:#000;background:none;border:0px;cursor:pointer;width:40px}
  .txt-search{font-size:22px;margin-top:60px;font-weight:bold;position:relative!important;padding-top:50px!important;}
  input{position:relative;background:#fff;border:solid thin #ccc;border-radius:10px;width:40%;padding:15px;font-size:18px;top:10vh;}
  .result{width:80%;margin:20px auto!important;height:70vh;overflow-y:auto;padding:0px !important;margin-top:100px!important;}
  .result .product-card{display:inline-block;max-width:200px;height:250px!important;vertical-align:top;margin:10px;}
  .top .txt-search{top:0px!important;width:95%}
  #close-top{top:10px!important;bottom:inherit;height:20px}
}
</style>



// WEBPACK FOOTER //
// src/components/TopComponent.vue